<template>
  <div class="flex flex-col border-sm shadow-sm p-2">
    <div class="p-2 border-b border-gray-600">
      List of Changes
    </div>
    <div class="grid grid-cols-4"
      v-for="diff in schedulDataDiffList"
      :key="diff">
      <span class="text-sm font-bold col-span-1 text-end pr-4">{{ diff }}:</span>
      <span class="text-sm col-span-3">Rest of data</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scheduleDataDiff: Object,
  },
  computed: {
    schedulDataDiffList() {
      if (!this.scheduleDataDiff) {
        return []
      }
      return Object.keys(this.scheduleDataDiff)
    }
  }
}
</script>
